import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableContainer,
  Chip,
  Tooltip,
  Button,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  TextField, // ✅ Added for search bar
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import AddProfilePage from "../addSecurityProfile/addProfile";

import EditSecurityProfilePage from "../Editing/editSecurityprofile/editProfile";
import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
const SecurityProfilesPage = ({ data: initialData }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);

  const [data, setData] = useState(initialData || []);
  const [filteredData, setFilteredData] = useState(initialData || []); // ✅ Search filtering
  const [searchQuery, setSearchQuery] = useState(""); // ✅ Search state

  const [deletingId, setDeletingId] = useState(null);
  const [confirmDeleteProfile, setConfirmDeleteProfile] = useState(null);
const [deleting, setDeleting] = useState(false);

  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  const EncryptedInstanceId=localStorage.getItem("EncryptedId");
  const fetchSecurityProfiles = async () => {
    const payload = {
      action: "listsecurityprofiles",
      ID:EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
    };

    try {
      const res = await axiosInstance.post(
        endpoints.displaysecurityprofile.securityprofile,
        payload
      );
      const parsed = JSON.parse(res.data?.body || "{}");
      const securityProfilesArray = Array.isArray(parsed.securityProfiles)
        ? parsed.securityProfiles
        : [];

      const updatedData = securityProfilesArray.map((item) => ({
        securityProfileARN: item.Arn,
        securityProfileId: item.Id,
        name: item.SecurityProfileName,
        description: item.Description || "",
        permissions: item.Permissions || [],
        tags: item.Tags || {},
        allowedAccessControlTags: item.AllowedAccessControlTags || {},
        lastModifiedTime: item.LastModifiedTime || "",
        instanceId: item.InstanceId || "",
      }));

      setData(updatedData);
      setFilteredData(updatedData); // ✅ Sync with search list
    } catch (error) {
      console.error("Failed to fetch security profiles:", error);
      setData([]);
      setFilteredData([]);
    }
  };

  const handleDelete = async (profileId, profileName) => {
    const payload = {
      action: "deletesecurityprofile",
      ID:EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
      securityProfileName: profileName,
    };

    try {
      setDeletingId(profileId);
      await axiosInstance.post(
        endpoints.displaysecurityprofile.securityprofile,
        payload
      );
      await fetchSecurityProfiles();
    } catch (error) {
      console.error("Failed to delete profile:", error);
    } finally {
      setDeletingId(null);
    }
  };

  const handleProfileAdded = (newProfile) => {
    const updated = [...data, newProfile];
    setData(updated);
    setFilteredData(updated);
  };

  const handleProfileUpdated = (updatedProfile) => {
    const updated = data.map((p) =>
      p.securityProfileId === updatedProfile.securityProfileId
        ? updatedProfile
        : p
    );
    setData(updated);
    setFilteredData(updated);
    setEditingProfile(null);
  };

  const [copiedArn, setCopiedArn] = useState("");
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedArn(text);
      setTimeout(() => setCopiedArn(""), 1500); // clear after 1.5s
    });
  };

  // ✅ Handle search
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (!query) {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((profile) => {
      return (
        (profile.name || "").toLowerCase().includes(query) ||
        (profile.description || "").toLowerCase().includes(query) ||
        (profile.securityProfileARN || "").toLowerCase().includes(query) ||
        profile.permissions.some((perm) =>
          perm.toLowerCase().includes(query)
        )
      );
    });

    setFilteredData(filtered);
  };

  // ✅ If adding or editing
  if (showAddForm) {
    return (
      <AddProfilePage
        onClose={() => setShowAddForm(false)}
        onProfileAdded={handleProfileAdded}
        instanceAlias={instanceAlias}
        instanceId={instanceId}
        customerAWSAccountId={customerAWSAccountId}
        region={region}
      />
    );
  }

  if (editingProfile) {
    return (
      <EditSecurityProfilePage
        profile={editingProfile}
        onClose={() => setEditingProfile(null)}
        onUpdate={handleProfileUpdated}
      />
    );
  }

  return (
    <Box>
     <Typography variant="h5"className="phone-number-title" >
             Security Profiles
           </Typography>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
       

        <TextField
  placeholder="Search..."
  value={searchQuery}
  className="search-textfield"
  onChange={handleSearchChange}  // live filtering
  
  sx={{ width: 100 }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <SearchIcon />
      </InputAdornment>
    ),
  }}
/>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setShowAddForm(true)}
        >
          Add Security Profile
        </Button>
      </Box>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#e8f0fe" }}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Permissions</TableCell>
              <TableCell>ARN</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((profile, idx) => (
                <TableRow key={idx}>
                  <TableCell>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setEditingProfile(profile);
                      }}
                      style={{
                        textDecoration: "underline",
                        color: "#1976d2",
                        cursor: "pointer",
                      }}
                    >
                      {profile.name}
                    </a>
                  </TableCell>
                  <TableCell>{profile.description || "-"}</TableCell>
                  <TableCell>
                    {profile.permissions?.slice(0, 3).map((perm, i) => (
                      <Chip
                        key={i}
                        label={perm}
                        size="small"
                        sx={{ m: 0.3, backgroundColor: "#e3f2fd" }}
                      />
                    ))}
                    {profile.permissions?.length > 3 && (
                      <Tooltip title={profile.permissions.join(", ")}>
                        <Chip
                          label={`+${profile.permissions.length - 3} more`}
                          size="small"
                        />
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell>
  <Tooltip title={copiedArn === profile.securityProfileARN ? "Copied" : "Copy ARN"}>
    <IconButton onClick={() => handleCopy(profile.securityProfileARN)}>
      <ContentCopyOutlinedIcon
        color={copiedArn === profile.securityProfileARN ? "primary" : "inherit"}
        fontSize="small"
      />
    </IconButton>
  </Tooltip>
</TableCell>

                  <TableCell>
                    <IconButton
                      color="error"
                      onClick={() => setConfirmDeleteProfile(profile)} // ✅ Open modal
                      disabled={deletingId === profile.securityProfileId}
                    >
                      {deletingId === profile.securityProfileId ? (
                        <CircularProgress size={18} />
                      ) : (
                        <DeleteIcon />
                      )}
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No matching profiles found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

     {/* ✅ Confirmation Modal */}
<Dialog
  open={!!confirmDeleteProfile}
  onClose={deleting ? null : () => setConfirmDeleteProfile(null)}
  disableEscapeKeyDown={deleting}
>
  <DialogTitle>Confirm Deletion</DialogTitle>
  <DialogContent>
    Are you sure you want to delete the security profile{" "}
    <strong>{confirmDeleteProfile?.name}</strong>?
  </DialogContent>
  <DialogActions>
    {/* Cancel Button */}
    <Button
      variant="outlined"
      onClick={() => setConfirmDeleteProfile(null)}
      disabled={deleting}
    >
      Cancel
    </Button>

    {/* Delete Button */}
    <Button
      color="error"
      variant="contained"
      disabled={deleting}
      startIcon={deleting ? <CircularProgress size={18} color="inherit" /> : null}
      onClick={async () => {
        if (confirmDeleteProfile) {
          setDeleting(true);
          try {
            await handleDelete(
              confirmDeleteProfile.securityProfileId,
              confirmDeleteProfile.name
            );
          } catch (error) {
            console.error("Delete failed:", error);
          } finally {
            setDeleting(false);
            setConfirmDeleteProfile(null);
          }
        }
      }}
    >
      {deleting ? "Deleting..." : "Delete"}
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default SecurityProfilesPage;
